var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"facebook-card"},[_c('skeleton-loader-vue',{staticClass:"shimmer-accordion",attrs:{"type":"ract","height":60,"animation":"wave"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }